import { render, staticRenderFns } from "./EmotionGameBrain.vue?vue&type=template&id=d3ebb3e0&scoped=true&"
import script from "./EmotionGameBrain.vue?vue&type=script&lang=js&"
export * from "./EmotionGameBrain.vue?vue&type=script&lang=js&"
import style0 from "./EmotionGameBrain.vue?vue&type=style&index=0&id=d3ebb3e0&scoped=true&lang=scss&"
import style1 from "./EmotionGameBrain.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ebb3e0",
  null
  
)

export default component.exports